// Global Components
import * as React from 'react';

// Types
type $Item = {
  Name: string;
  Value: string;
};

type $OptionalProps = {
  className?: string;
  placeholder?: string;
};

type $Props = $OptionalProps & {
  data: Array<$Item>;
  setItem: (arg0: string) => unknown;
};

type $State = {
  activeValue: string;
};

class FilterSelectView extends React.Component<$Props, $State> {
  static defaultProps: $OptionalProps = {
    className: undefined,
    placeholder: undefined,
  };

  constructor(props: $Props) {
    super(props);

    this.state = {
      activeValue: '',
    };
  }

  render() {
    const {
      className,
      data,
      placeholder,
      setItem,
    } = this.props;
    const {
      activeValue,
    } = this.state;

    return (
      <div className={`FilterSelect custom-select ${className || ''}`}>
        <select
          className={'form-control rounded-full relative btn_primary btn_outlined uppercase py-2 text-gray-600 h-full w-full'}
          onChange={(e) => {
            const {
              value,
            } = e.target;

            this.setState({
              activeValue: value,
            });

            setItem(value);
          }}
        >
          <option value={''}>
            {activeValue !== '' ? '' : placeholder}
          </option>
          {data.map((item: $Item) => (
            <option
              key={item.Value}
              value={item.Value}
            >
              {item.Name}
            </option>
          ))}
        </select>
      </div>
    );
  }
}

export default FilterSelectView;
